export function elementIsOrHasFixedPosition( element: HTMLElement ): boolean {
    if ( !element ) {
        return false;
    }

    let node: HTMLElement | null = element;

    while ( node && node.nodeType === Node.ELEMENT_NODE ) {
        if ( getComputedStyle( node ).position === 'fixed' ) {
            return true;
        }

        node = node.parentElement;
    }

    return false;
}
